/**
 * Formats a given float as a price, with no decimals if there are none, or 2 if there are.
 * @param {Float} price
 * @param {Object} priceMapping
 * @returns {String}
 */
export function formatAsPrice(price, priceMapping = undefined) {
    // Set localization formatting.
    let countyPriceMapping = {
        localization: 'de-DE',
        showZeros: false,
    };
    if (priceMapping != undefined) {
        countyPriceMapping = priceMapping;
    }

    // Format with 2 decimals if price as any decimals.
    if (price % 1 != 0 || countyPriceMapping.showZeros) {
        return price.toLocaleString(countyPriceMapping.localization, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

    // Format with no decimal digits.
    return price.toLocaleString(countyPriceMapping.localization);
}
